<template>
  <div class="sticker-bar" data-scroll :style="{backgroundColor: _.get(contentData, 'conf.colorBg')}">
    <img
      class="left-sticker"
      src="@/assets/img/drinkcoldsticker.png"
      alt="მიირთვით ცივად"
    />
    <img
      class="right-sticker"
      src="@/assets/img/madeingeorgia.png"
      alt="დამზადებულია საქართველოში"
    />
  </div>
</template>

<script>
export default {
  props: ['bgColor', 'contentData'],
};
</script>

<style lang="scss" scoped>
.sticker-bar {
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding-left: 41.1px;
  padding-right: 29px;
  align-items: center;
  height: 95.7px;
  background-color: white;
  transform: translateY(80px);
  transition: all cubic-bezier(0, 0.08, 0.06, 0.99) 0.8s;
  img {
    max-height: 61.7px;
    width: auto;
    object-fit: cover;
  }
  &.is-inview {
    transform: translateY(0);
  }
}
@media (max-width: 1023px) {
  .sticker-bar {
    padding-left: 46px;
    padding-right: 47px;
  }
}

@media (max-width: 767px) {
  .sticker-bar {
    justify-content: flex-end;
    .left-sticker {
      display: none;
    }
    padding-left: 0;
    padding-right: 17px;
  }
}
</style>
